/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from '../ContentLoader/ContentLoader';
import './Button.scss';

const Button = ({
  label,
  onInvoked,
  isLoading,
  children,
}) => (
  <button
    onClick={() => {
      if (onInvoked !== undefined && onInvoked !== null) {
        onInvoked();
      }
    }}
    type="button"
    className="primary-button"
  >
    {!isLoading && !children && label}
    {!isLoading && !label && children}
    {isLoading && (
      <ContentLoader />
    )}
  </button>
);

Button.propTypes = {
  label: PropTypes.string,
  onInvoked: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
};

Button.defaultProps = {
  label: undefined,
  onInvoked: undefined,
  isLoading: false,
  children: undefined,
};

export default Button;
